import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';

import {AdministradorComponent} from './administrador/administrador.component';

import {DirectorioComponent} from './directorio/directorio.component';
import {FuentesComponent} from './directorio/fuentes/fuentes.component';
import {VariableschvComponent} from './directorio/variableschv/variableschv.component';
import {AdminvariableschvComponent} from './directorio/variableschv/adminvariableschv/adminvariableschv.component';
import {VariablesfiviComponent} from './directorio/variablesfivi/variablesfivi.component';
import {AdminvariablesfiviComponent} from './directorio/variablesfivi/adminvariablesfivi/adminvariablesfivi.component';
import {NuevafuenteComponent} from './directorio/fuentes/nuevafuente/nuevafuente.component';
import {EditarfuenteComponent} from './directorio/fuentes/editarfuente/editarfuente.component';
import {ActivacionComponent} from './directorio/fuentes/activacion/activacion.component';

import {UsuariosComponent} from './usuarios/usuarios.component';
import {UsuariodaneComponent} from './usuarios/usuariodane/usuariodane.component';
import {UsuariochvComponent} from './usuarios/usuariochv/usuariochv.component';
import {UsuariofiviComponent} from './usuarios/usuariofivi/usuariofivi.component';
import {EditarusuarioComponent} from './usuarios/editarusuario/editarusuario.component';

import {CaratulaComponent} from './Fuentes/caratula/caratula.component';
import {CarguemComponent} from './Fuentes/carguem/carguem.component';
import {CarguemsuperComponent} from './Fuentes/carguemsuper/carguemsuper.component';
import {CarguemfiviComponent} from './Fuentes/carguemfivi/carguemfivi.component';
import {NovedadesComponent} from './Fuentes/novedades/novedades.component';
import {ConsultareportComponent} from './Fuentes/consultareport/consultareport.component';

import {CambioclaveComponent} from './plantillas/cambioclave/cambioclave.component';

import {ParametricasComponent} from './parametricas/parametricas.component';
import {VariableComponent} from './parametricas/variable/variable.component';
import {SuperintendenciaComponent} from './parametricas/superintendencia/superintendencia.component';
import {TipoentidadComponent} from './parametricas/tipoentidad/tipoentidad.component';
import {TipocreditoComponent} from './parametricas/tipocredito/tipocredito.component';
import {ParametricaschvComponent} from './parametricas/parametricaschv/parametricaschv.component';
import {ParametricasfiviComponent} from './parametricas/parametricasfivi/parametricasfivi.component';

import {CalendarioComponent} from './calendario/calendario.component';
import {CalendariochvComponent} from './calendario/calendariochv/calendariochv.component';
import {CalendariofiviComponent} from './calendario/calendariofivi/calendariofivi.component';

import {AnalisisComponent} from './analisis/analisis.component';
import {AnalisischvComponent} from './analisis/analisischv/analisischv.component';
import {AnalisisfiviComponent} from './analisis/analisisfivi/analisisfivi.component';

import {AdmininfoComponent} from './admininfo/admininfo.component';
import {AdmininfchvComponent} from './admininfo/admininfchv/admininfchv.component';
import {ConsultarinforchvComponent} from './admininfo/admininfchv/consultarinforchv/consultarinforchv.component';
import {CargueminformchvComponent} from './admininfo/admininfchv/cargueminformchv/cargueminformchv.component';
import {ActivarcargueComponent} from './admininfo/admininfchv/activarcargue/activarcargue.component';
import {CrearnovedadComponent} from './admininfo/admininfchv/crearnovedad/crearnovedad.component';
import {AdmininffiviComponent} from './admininfo/admininffivi/admininffivi.component';
import {ConsultarinfofiviComponent} from './admininfo/admininffivi/consultarinfofivi/consultarinfofivi.component';
import {CargueminformfiviComponent} from './admininfo/admininffivi/cargueminformfivi/cargueminformfivi.component';
import {ActivarcarguefiviComponent} from './admininfo/admininffivi/activarcarguefivi/activarcarguefivi.component';
import {CrearnovedadfiviComponent} from './admininfo/admininffivi/crearnovedadfivi/crearnovedadfivi.component';
import {OperativoComponent} from './operativo/operativo.component';
import {OperativochvComponent} from './operativo/operativochv/operativochv.component';
import {OperativofiviComponent} from './operativo/operativofivi/operativofivi.component';
import {OperativofivitrimestralComponent} from './operativo/operativofivitrimestral//operativofivitrimestral.component';
import {IndicadoresComponent} from './indicadores/indicadores.component';
import {IndicadoreschvComponent} from './indicadores/indicadoreschv/indicadoreschv.component';
import {IndicadoresfiviComponent} from './indicadores/indicadoresfivi/indicadoresfivi.component';
import {IndicadoresfivitrimestralComponent} from './indicadores/indicadoresfivitrimestral/indicadoresfivitrimestral.component';
import {CuadrosSalidaComponent} from './cuadrosSalida/cuadrosSalida.component';
import {CuadrosSalidaChvComponent} from './cuadrosSalida/cuadrosSalidaChv/cuadrosSalidaChv.component';
import {CuadrosSalidaFiviComponent} from './cuadrosSalida/cuadrosSalidaFivi/cuadrosSalidaFivi.component';


const routes: Routes = [
  { path: '', redirectTo:'login' , pathMatch:'full' },
  { path: 'login', component: LoginComponent },
  { path: 'admin', component: AdministradorComponent },

  //usuarios DANE
  { path: 'directorio', component: DirectorioComponent },
  { path: 'usuarios', component: UsuariosComponent },
  { path: 'fuentes', component: FuentesComponent },
  { path: 'nuevafuente', component: NuevafuenteComponent },
  { path: 'editarfuente/:id', component: EditarfuenteComponent },
  { path: 'activar/:id', component: ActivacionComponent },
  { path: 'variableschv', component: VariableschvComponent },
  { path: 'administrarvariableschv/:id', component: AdminvariableschvComponent },
  { path: 'variablesfivi', component: VariablesfiviComponent },
  { path: 'administrarvariablesfivi/:id', component: AdminvariablesfiviComponent },
  { path: 'nuevouserdane', component: UsuariodaneComponent },
  { path: 'nuevouserchv', component: UsuariochvComponent },
  { path: 'nuevouserfivi', component: UsuariofiviComponent },
  { path: 'editarusuario/:id', component: EditarusuarioComponent },
  { path: 'parametricas', component: ParametricasComponent },
  { path: 'variable/:id', component: VariableComponent },
  { path: 'superintendencia/:id', component: SuperintendenciaComponent },
  { path: 'tipoentidad', component: TipoentidadComponent },
  { path: 'tipocredito', component: TipocreditoComponent },
  { path: 'parametricaschv', component: ParametricaschvComponent },
  { path: 'parametricasfivi', component: ParametricasfiviComponent },
  { path: 'calendario', component: CalendarioComponent },
  { path: 'calendariochv', component: CalendariochvComponent },
  { path: 'calendariofivi', component: CalendariofiviComponent },
  { path: 'analisis', component: AnalisisComponent },
  { path: 'analisischv', component: AnalisischvComponent },
  { path: 'analisisfivi', component: AnalisisfiviComponent },
  { path: 'admininfo', component: AdmininfoComponent },
  { path: 'admininfochv', component: AdmininfchvComponent },
  { path: 'consultarinfochv', component: ConsultarinforchvComponent },
  { path: 'carguemasivoinfochv', component: CargueminformchvComponent },
  { path: 'activarcarguechv', component: ActivarcargueComponent },
  { path: 'crearnovedadchv', component: CrearnovedadComponent },
  { path: 'admininfofivi', component: AdmininffiviComponent },
  { path: 'consultarinfofivi', component: ConsultarinfofiviComponent },
  { path: 'carguemasivoinfofivi', component: CargueminformfiviComponent },
  { path: 'activarcarguefivi', component: ActivarcarguefiviComponent },
  { path: 'crearnovedadfivi', component: CrearnovedadfiviComponent },
  { path: 'operativo', component: OperativoComponent },
  { path: 'operativochv', component: OperativochvComponent },
  { path: 'operativofivi-mensual', component: OperativofiviComponent },
  { path: 'operativofivi-trimestral', component: OperativofivitrimestralComponent },
  { path: 'indicadores', component: IndicadoresComponent },
  { path: 'indicadoreschv', component: IndicadoreschvComponent },
  { path: 'indicadoresfivi-mensual', component: IndicadoresfiviComponent },
  { path: 'indicadoresfivi-trimestral', component: IndicadoresfivitrimestralComponent },
  { path: 'CuadrosSalida', component: CuadrosSalidaComponent },
  { path: 'CuadrosSalidaChv', component: CuadrosSalidaChvComponent },
  { path: 'CuadrosSalidaFivi', component: CuadrosSalidaFiviComponent },

  //fuentes o reportantes
  { path: 'caratula', component: CaratulaComponent },
  { path: 'cambiarclave', component: CambioclaveComponent },
  { path: 'carguemasivo', component: CarguemComponent },
  { path: 'carguemasivosuper', component: CarguemsuperComponent },
  { path: 'carguemasivofivi', component: CarguemfiviComponent },
  { path: 'novedades', component: NovedadesComponent },
  { path: 'consultareporte', component: ConsultareportComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
